import(/* webpackMode: "eager", webpackExports: ["MyPageShell"] */ "/vercel/path0/components/profile/MyPageShell.tsx");
